import { HTTP_GET } from '../const';
import { LOAD_AML_BALANCE, LOAD_BALANCES } from "@/store/const/node";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    [LOAD_BALANCES]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_BALANCES,
        namespace: 'node',
        no_commit: true,
      }, { root: true });
    },
    [LOAD_AML_BALANCE]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_AML_BALANCE,
        namespace: 'node',
        no_commit: true,
      }, { root: true });
    },
  },
  mutations: {},
};
